import React, { useState, useEffect } from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  const [totalCount, setTotalCount] = useState(1683);

  useEffect(() => {
    // Fetch live total contributions count (public + private) from streak stats service
    fetch(
      "https://github-readme-streak-stats-theta-tawny.vercel.app/?user=TarunTalan&theme=tokyonight&hide_border=true"
    )
      .then((res) => res.text())
      .then((svg) => {
        const match = svg.match(
          /Total Contributions big number[\s\S]*?<text[^>]*>\s*([0-9,]+)\s*<\/text>/i
        );
        if (match && match[1]) {
          const parsed = parseInt(match[1].replace(/,/g, ""), 10);
          if (!isNaN(parsed) && parsed > 0) {
            setTotalCount(parsed);
          }
        }
      })
      .catch((err) => {
        console.warn("Could not fetch streak stats count, using default:", err);
      });
  }, []);

  return (
    <Row
      style={{
        justifyContent: "center",
        paddingBottom: "10px",
        color: "white",
      }}
    >
      <h1 className="project-heading pb-4" style={{ paddingBottom: "20px" }}>
        Days I <strong className="purple">Code</strong>
      </h1>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          overflowX: "auto",
          padding: "10px 0",
        }}
      >
        <GitHubCalendar
          username="TarunTalan"
          blockSize={15}
          blockMargin={5}
          color="#c084f5"
          fontSize={16}
          totalCount={totalCount}
          labels={{
            totalCount: `${totalCount.toLocaleString()} contributions across all repositories`,
          }}
        />
      </div>
    </Row>
  );
}

export default Github;
